
export default {
  head() {
    return {
      title: "Agence Google Ads | SEA à Nancy dès 290€/mois – ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads à Nancy certifiée Google Partner, aide les entreprises nancéiennes à développer leurs contacts et à maximiser leur ROI.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Agence Google Ads à Nancy dès 290€/mois – ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads à Nancy certifiée Google Partner, aide les entreprises nancéiennes à développer leurs contacts et à maximiser leur ROI.",
        },
      ],
    };
  },
};
